
// Type utilities for status and priority
import { 
  CircleCheck, 
  AlertTriangle, 
  Clock, 
  CheckCheck,
  Circle,
  X,
  LucideIcon 
} from 'lucide-react';

export type StatusType = "not-started" | "in-progress" | "delayed" | "completed" | string;
export type PriorityType = "high" | "medium" | "low" | string;

export const getStatusColor = (status: StatusType): string => {
  switch (status) {
    case "not-started":
      return "bg-gray-100 text-gray-800";
    case "in-progress":
      return "bg-blue-100 text-blue-800";
    case "delayed":
      return "bg-amber-100 text-amber-800";
    case "completed":
      return "bg-green-100 text-green-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const getPriorityColor = (priority: PriorityType): string => {
  switch (priority) {
    case "high":
      return "bg-red-100 text-red-800";
    case "medium":
      return "bg-amber-100 text-amber-800";
    case "low":
      return "bg-blue-100 text-blue-800";
    default:
      return "bg-gray-100 text-gray-800";
  }
};

export const getStatusIcon = (status: StatusType) => {
  switch (status) {
    case "completed":
      return "check-circle";
    case "delayed":
      return "clock";
    case "in-progress":
      return "clock";
    default:
      return "clock";
  }
};

export const getProgressColor = (progress: number): string => {
  if (progress < 30) return "bg-red-500";
  if (progress < 70) return "bg-amber-500";
  return "bg-green-500";
};

// Add the getIconByName function
export const getIconByName = (iconName: string): LucideIcon => {
  switch (iconName?.toLowerCase()) {
    case 'circlecheck':
      return CircleCheck;
    case 'alerttriangle':
      return AlertTriangle;
    case 'clock':
      return Clock;
    case 'checkcheck':
      return CheckCheck;
    case 'x':
      return X;
    default:
      return Circle;
  }
};
